<template>
    <v-dialog v-model="showDialog" max-width="1000">
        <v-card ref="scrollContainer" style="position: relative; max-height: 80vh; overflow-y: auto; position: relative;">
            <!-- :loading="loading.tempDoctor" -->
            <v-card-title style="padding: 30px 30px 20px 30px; border-bottom: 1px solid #eee;">
                <div class="doctor-table-dialog-doctor-name d-flex align-center">
                    <v-icon
                        :size="screen_width > 599 ? 45 : 30"
                        class="gradient-icon mr-2 ml-n2"
                    >
                        {{ mdiDoctor }}
                    </v-icon>
                    <span :style="`font-size: ${screen_width > 599 ? 2.4 : 1.4}rem;`">Dr. {{ toTitleCase(doctor && doctor.doc_name) }}</span>
                </div>
                <div style="margin: 0 0 0 0; color: white; word-break: normal; display: block; width: 100%;">
                    <span style="color: #555;">{{ doctor && doctor.sp_desc }}</span>
                </div>
                <v-btn
                    style="position: absolute; right: 18px; top: 35px; background: transparent;"
                    icon
                    large
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text style="margin-top: 10px; margin-top: 15px;">
                <div class="doctor-table-dialog-subtitle">
                    <v-icon color="success" style="margin-bottom: 2px;">
                        {{ mdiHospitalBuilding }}
                    </v-icon>&nbsp;<span style="margin-top: 3px !important;">Hospital Affiliations & Schedule</span>
                </div>
                <v-card style="margin: 10px 0; background: rgb(243, 253, 246);">
                    <v-row style="padding: 15px; margin: 17px 0; width: 100%;">
                        <v-col cols="12">
                            <span style="font-weight: 700;">SEARCH HOSPITALS</span>
                            <v-autocomplete
                                v-model="filterHospital"
                                dense
                                :items="sortedHospitals"
                                hide-details
                                outlined
                                clearable
                                color="success"
                                style="background-color: white;"
                            />
                        </v-col>
                        <!-- <v-col :md="undefined" style="max-width: 100%;">
                            <span style="font-weight: 700; display: block;">QUICK FILTERS</span>
                            <v-btn
                                :style="`margin: 2px 5px; ${quickFilter === 'all' ? 'background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%); color: white;' : '' } border-radius: 25px; text-transform: none;`"
                                @click="quickFilter = 'all'"
                            >
                                All
                            </v-btn>
                            <v-btn
                                :style="`margin: 2px 5px; ${quickFilter === 'withSchedule' ? 'background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%); color: white;' : '' } border-radius: 25px; text-transform: none;`"
                                @click="quickFilter = 'withSchedule'"
                            >
                                With Schedule
                            </v-btn>
                            <v-btn
                                :style="`margin: 2px 5px; ${quickFilter === 'withRoom' ? 'background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%); color: white;' : '' } border-radius: 25px; text-transform: none;`"
                                @click="quickFilter = 'withRoom'"
                            >
                                With Room
                            </v-btn>
                        </v-col> -->
                    </v-row>
                </v-card>
                <div v-if="filterDoctors && filterDoctors.length > 0">
                    <span style="color: #555; font-weight: 700;">Showing {{ filterDoctors.length }} of {{ filterDoctors.length }} hospitals</span>
                    <v-card
                        v-for="(value, index) in filterDoctors"
                        :key="index"
                        class="doctor-table-dialog-gradient-border-card"
                        style="background: rgb(243, 253, 246);"
                    >
                        <v-card-title style="font-weight: 700; color: #2c5530; word-break: normal;">
                            {{ value.hosp_name }}
                        </v-card-title>
                        <v-card-text>
                            <v-row cols="12">
                                <v-col
                                    v-if="value.af_roomno != null && String(value.af_roomno).trim() !== ''"
                                    lg="4"
                                    md="6"
                                    cols="12"
                                >
                                    <v-card class="doctor-table-dialog-card-info" style="padding: 10px; height: 100%; border-radius: 10px;">
                                        <span class="doctor-table-dialog-card-info-label"><v-icon class="doctor-table-dialog-card-info-label-address"> {{ mdiHomeMapMarker }}</v-icon>&nbsp;ROOM NUMBER</span><span class="doctor-table-dialog-card-info-address">{{ value.af_roomno !== null && String(value.af_roomno).trim() !== '' ? value.af_roomno : '(Not specified)' }}</span>
                                    </v-card>
                                </v-col>
                                <v-col
                                    v-if="value.af_sched != null && String(value.af_sched).trim() !== ''"
                                    lg="4"
                                    md="6"
                                    cols="12"
                                >
                                    <v-card class="doctor-table-dialog-card-info" style="padding: 10px; height: 100%; border-radius: 10px;">
                                        <span class="doctor-table-dialog-card-info-label"><v-icon class="doctor-table-dialog-card-info-label-address">{{ mdiClockTimeThreeOutline }}</v-icon>&nbsp;SCHEDULE</span><span class="doctor-table-dialog-card-info-address">{{ value.af_sched !== null && String(value.af_sched).trim() !== '' ? value.af_sched : '(Contact hospital for schedule)' }}</span>
                                    </v-card>
                                </v-col>
                                <v-col lg="4" md="6" cols="12">
                                    <v-card class="doctor-table-dialog-card-info" style="padding: 10px; height: 100%; border-radius: 10px;">
                                        <span class="doctor-table-dialog-card-info-label"><v-icon class="doctor-table-dialog-card-info-label-address">{{ mdiMapMarker }}</v-icon>&nbsp;ADDRESS</span><span class="doctor-table-dialog-card-info-address">{{ value.hosp_address }}</span>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-else>
                    <v-col class="text-center" style="border-radius: 12px; border: 2px dashed #4EB352;">
                        <v-icon style="font-size: 100px;" color="success">
                            {{ mdiMapSearchOutline }}
                        </v-icon>
                        <h1 style="margin: 30px 0; color: #4CAF50; font-size: 23px;">
                            No Hospitals Found
                        </h1>
                        <p>We couldn't find any hospitals matching your search criteria. Try adjusting your filters.</p>
                        <div class="text-center">
                            <v-btn
                                style="background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%); color: white; border-radius: 25px; text-transform: none;"
                                @click="handleResetFiltersFunc"
                            >
                                <v-icon>{{ mdiReload }}</v-icon>&nbsp;Reset All Filters
                            </v-btn>
                        </div>
                    </v-col>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClockTimeThreeOutline, mdiClose, mdiDoctor, mdiHomeMapMarker, mdiHospitalBuilding, mdiMapMarker, mdiMapSearchOutline, mdiReload } from '@mdi/js'
import { mapGetters } from 'vuex'
export default {
    props: ['show', 'doctor', 'loading'],
    data() {
        return {
            mdiClockTimeThreeOutline, mdiClose, mdiDoctor, mdiHomeMapMarker, mdiHospitalBuilding, mdiMapMarker, mdiMapSearchOutline, mdiReload,
            screen_width: document.documentElement.clientWidth + 9,
            searchHospital: null,
            filterHospital: null,
            quickFilter: 'all',
            headers: [
                {
                    text: 'Hospital',
                    sortable: true,
                    value: 'hosp_name'
                },
                {
                    text: 'Room Number',
                    sortable: true,
                    value: 'af_roomno'
                },
                {
                    text: 'Schedule',
                    sortable: true,
                    value: 'af_sched'
                },
                {
                    text: 'Address',
                    sortable: false,
                    value: 'hosp_address'
                }
            ]
        }
    },
    computed: {
        // ...mapGetters({ doctors_dialog_getter: 'doctor/doctors_dialog_getter' }),
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getSpecializations', 'getDoctors', 'getDoctorDialog']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.handleResetFiltersFunc()
                this.$emit('closeDialog')
            }
        },
        hospitals() {
            const seen = new Set()
            return ((this.doctor && this.doctor.affiliates) || []).filter(a => {
                const key = a.af_vendor_code
                if (seen.has(key)) return false
                seen.add(key)
                return true
            })
        },
        sortedHospitals() {
            const names = this.hospitals.map(h => (h.hosp_name || '').trim()).filter(Boolean)
            return [...new Set(names)].sort((a, b) => a.localeCompare(b))
        },
        filterDoctors() {
            const hospitalFilter = (this.filterHospital || '').toLowerCase()
            if (!hospitalFilter) return this.hospitals
            return this.hospitals.filter(h => (h.hosp_name || '').trim().toLowerCase().includes(hospitalFilter))
        }
    },
    watch: {
        show(newVal) {
            if (!newVal) {
                this.handleResetFiltersFunc()
            }
        },
        'loading.tempDoctor'(newVal) {
            if (newVal) {
                this.handleResetFiltersFunc()
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.updateHeight)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateHeight)
    },
    methods: {
        updateHeight() {
            this.screen_width = document.documentElement.clientWidth
        },
        handleResetFiltersFunc() {
            this.searchHospital = null
            this.filterHospital = null
            this.quickFilter = 'all'
        },
        toTitleCase(str) {
            if (str) {
                return str
                    .toLowerCase()
                    .replace(/\b\w+/g, word => word.charAt(0).toUpperCase() + word.slice(1))
            }
        }
    }
}
</script>

<style>
.doctor-table-dialog-title {
  width: 100%;
  font-size: 1.8rem;
  display: block;
  font-weight: 700;
  margin-bottom: 5px;
  color: white;
}
.doctor-table-dialog-doctor-name, .doctor-table-dialog-doctor-name span {
  margin: 0;
  padding: 0;
  width: 100%;
  display: block;
  background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  text-shadow: 0 2px 8px rgba(245, 222, 222, 0.1);
  letter-spacing: 0.5px;
  word-break: normal;
}
.doctor-table-dialog-subtitle {
  font-weight: 700;
  font-size: 22px;
  color: #555;
}
.doctor-table-dialog-gradient-border-card {
  background: rgb(243, 253, 246);
  position: relative;
  margin: 15px 0;
  padding-left: 8px; /* space for the gradient */
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
  .doctor-table-dialog-gradient-border-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    height: 100%;
    background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%);
    border-radius: 12px 0 0 12px;
  }
  .doctor-table-dialog-gradient-border-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(78, 179, 82, 0.15);
    border-color: #4EB352;
  }
  .doctor-table-dialog-card-info {
    font-size: 1.1rem;
    border-radius: 10px;
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  }
    .doctor-table-dialog-card-info:hover {
      transform: translateY(-3px);
      border-color: #4EB352;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
      .doctor-table-dialog-card-info-label {
        color: #4EB352;
        font-size: 15px; display: block; margin-bottom: 15px; color: #555; font-weight: 700; line-height: 1.5;
      }
    .doctor-table-dialog-card-info-room-number,
    .doctor-table-dialog-card-info-room-schedule {
      width: fit-content; /* Adjust as needed */
      height: auto; /* Adjust to fit two lines */
      padding: 5px;
      margin-top: 5px;
      border-radius: 3px;
      background: linear-gradient(135deg, #4EB352 0%, #20B2AA 100%);
      color: white;
      font-weight: 700;
      font-size: 0.875rem; /* Equivalent to 14px */
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      text-wrap: balance; /* Optional: improves line break aesthetics */
    }
    .doctor-table-dialog-card-info-unavailable {
        color: #555;
        font-style: italic;
    }
    .doctor-table-dialog-card-info-label-room {
      color: #4EB352 !important;
    }
    .doctor-table-dialog-card-info-label-schedule {
      color: rgb(61, 219, 240) !important;
    }
    .doctor-table-dialog-card-info-label-address {
      color: #4EB352 !important;
    }
    .doctor-table-dialog-card-info .doctor-table-dialog-card-info-room-schedule {
      font-size: 14px;
    }
    .doctor-table-dialog-card-info .doctor-table-dialog-card-info-address {
      width: 100%;
      line-height: 1.5;
      color: #555;
      display: block;
    }
</style>
